import { createSlice } from '@reduxjs/toolkit';

import type { OAuth2Token } from './types';

export const slice = createSlice({
    initialState: {
        fieldViewToken: null as OAuth2Token | null
    },

    name: 'useFieldView',

    reducers: {
        fieldViewToken: (state, action) => {
            state.fieldViewToken = action.payload;
        }
    }
});

export default slice.reducer;
